module.exports = __webpack_public_path__ + "static/media/raff.0b7e27cd.jpg";